import React from 'react';
const ModalRedButton = ({onClick, text}) => {
    return (
        <button onClick={()=>onClick()} className='bg-red-600 p-2 mx-auto w-full rounded-lg text-gray-700'>{text.toUpperCase()}</button>
    );
}
 
export default ModalRedButton;